import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=552b40e0&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552b40e0')) {
      api.createRecord('552b40e0', component.options)
    } else {
      api.reload('552b40e0', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=552b40e0&", function () {
      api.rerender('552b40e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/Header.vue"
export default component.exports